import { useLocation, useParams } from "react-router";

import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Container from "@mui/material/Container";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Card, Grid } from "semantic-ui-react";
import AppleIcon from "@mui/icons-material/Apple";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("سماعة ابل", 159, 6.0, 24, 4.0),
  createData("سلك ايفون", 237, 9.0, 37, 4.3),
];

export default function Order({ t, i18n }) {
  let navigate = useNavigate();
  const { state } = useLocation();

  const { id } = useParams();
  React.useEffect(() => {
    console.log("id: ", state.invoice.orders);
  }, []);

  const [order, setOrder] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetch(
      `https://fatora-sa.herokuapp.com/api/v1/orders/getOrder/${state.invoice.orders}`
    )
      .then((res) => res.json())
      .then((data) => setOrder(data[0].orders))
      .then(() => setLoading(false))
      .catch((e) => console.log("error: ", e.message));
  }, []);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  return (
    <Container
      style={{ paddingTop: 100, height: 1000, backgroundColor: "#F6F6F6" }}
    >
      <Card style={{ width: "100%" }}>
        <CardContent style={{}}>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            تفاصيل الطلب {loading && <CircularProgress size={20} />}
          </Typography>
          <Typography variant="h5" component="div">
            {id}
          </Typography>
          <Typography sx={{ mb: 0 }} color="text.secondary">
            شركة الشحن:{" "}
            {state.invoice.isShipped
              ? `${state.invoice.shippingCompany}`
              : "جاري التنفيذ"}
          </Typography>
          {/* <Chip
            size="small"
            label={new Date(state.invoice.created_at).toLocaleDateString()}
            color="info"
          /> */}
          <Typography variant="body2">
            رقم الشحن :{" "}
            {state.invoice.isShipped
              ? `${state.invoice.trackingNumber}`
              : "جاري التنفيذ"}
          </Typography>
        </CardContent>
        {state.invoice.isShipped ? (
          <CardActions>
            <Button
              onClick={() =>
                window.location.replace(
                  `https://www.smsaexpress.com/sa/ar/trackingdetails?tracknumbers%5B0%5D=${state.invoice.trackingNumber.trim()}`
                )
              }
              size="small"
            >
              رابط الشحن
            </Button>
          </CardActions>
        ) : null}
      </Card>

      <TableContainer component={Paper}>
        <Table sx={{}} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell
                align={i18n.language === "ar" ? "left" : "right"}
                style={{ fontWeight: "bold" }}
              >
                المنتج
              </TableCell>
              <TableCell align="left" style={{ fontWeight: "bold" }}>
                الكمية
              </TableCell>
              <TableCell align="right" style={{ fontWeight: "bold" }}>
                السعر
              </TableCell>
              <TableCell align="right" style={{ fontWeight: "bold" }}>
                المجموع
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {order?.map((row) => (
              <TableRow onClick={() => console.log("here ...")} key={row.name}>
                <TableCell
                  align={i18n.language === "ar" ? "left" : "right"}
                  component="th"
                  scope="row"
                >
                  {row.name}
                </TableCell>
                <TableCell
                  align={i18n.language === "ar" ? "left" : "right"}
                  component="th"
                  scope="row"
                >
                  {row.qty}
                </TableCell>
                <TableCell
                  align={i18n.language === "ar" ? "right" : "left"}
                  component="th"
                  scope="row"
                >
                  {row.unit.toFixed(2)} ريال
                </TableCell>
                <TableCell align={i18n.language === "ar" ? "right" : "left"}>
                  {(row.unit * row.qty).toFixed(2)} ريال
                </TableCell>
              </TableRow>
            ))}

            <TableRow onClick={() => console.log("here ...")}>
              <TableCell
                align={i18n.language === "ar" ? "left" : "right"}
                component="th"
                scope="row"
              >
                تكلفة الشحن
              </TableCell>
              <TableCell
                align={i18n.language === "ar" ? "left" : "left"}
              ></TableCell>
              <TableCell
                align={i18n.language === "ar" ? "left" : "left"}
              ></TableCell>
              <TableCell align={i18n.language === "ar" ? "right" : "left"}>
                19.99 ريال
              </TableCell>
            </TableRow>
            <TableRow onClick={() => console.log("here ...")}>
              <TableCell
                align={i18n.language === "ar" ? "left" : "right"}
                component="th"
                scope="row"
              >
                الضريبة
              </TableCell>
              <TableCell
                align={i18n.language === "ar" ? "left" : "left"}
              ></TableCell>
              <TableCell
                align={i18n.language === "ar" ? "left" : "left"}
              ></TableCell>
              <TableCell align={i18n.language === "ar" ? "right" : "left"}>
                00.00 ريال
              </TableCell>
            </TableRow>
            <TableRow onClick={() => console.log("here ...")}>
              <TableCell
                align={i18n.language === "ar" ? "left" : "right"}
                component="th"
                scope="row"
              >
                المجموع الكلي
              </TableCell>
              <TableCell
                align={i18n.language === "ar" ? "left" : "left"}
              ></TableCell>
              <TableCell
                align={i18n.language === "ar" ? "left" : "left"}
              ></TableCell>
              <TableCell align={i18n.language === "ar" ? "right" : "left"}>
                {(state.invoice.price + 19.99).toFixed(2)} ريال
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}
